import styled from "styled-components";

const Text = styled.span<{ color?: string; fontSize?: string }>`
  color: ${({ color, theme }) => color || theme.colors.text};
  font-size: ${({ fontSize }) => fontSize || "0.8rem"};
`;

export default Text;
